import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import ListingTableView from '../../../../../product/components/organisms/Product/TableView'
import DynamicContext from '../../../../../product/context/dynamic/dynamicContext'
import ProductContext from '../../../../../product/context/userProduct/productContext'
import Loaders from '../../../../components/molecules/Loaders'
import BaseTablePage from '../../../species/dynamic/common/BaseTablePage'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import './Tabs.css'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

function BuyerBids(props) {
    const { tabLabels = {} } = props
    const {
        winning: winningLabel = 'Winning',
        outbid: outbidLabel = 'Outbid',
        won: wonLabel = 'Won',
    } = tabLabels
    const userProductContext = useContext(ProductContext)
    const { search_alldashboardproducts, getAllDashboardProducts } =
        userProductContext
    const dynamicContext = useContext(DynamicContext)
    const { project_tablefields } = dynamicContext
    const history = useHistory()

    const [value, setValue] = useState(0)
    const [tableValue, setTableValue] = useState([])
    const [dashboardValues, setDashboardValues] = useState([])
    const [tableBody, setTableBody] = useState([])
    const [action, setAction] = useState('winning')
    const [isLoading, setIsLoading] = useState(true)
    const [anchorEl, setAnchorEl] = useState(null)
    const [initialUpdate, setInitialUpdate] = useState(true)
    const [arrayValue, setArrayValue] = useState([])
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const formik = useFormik({
        initialValues: {
            limit: 12,
            page: 1,
            orderby: 'p.date_closed, asc',
            order: '',
            user_id: props.userId,
            action: action,
            filters: {
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'p.date_closed',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'p.date_closed',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            values.action = action
            getAllDashboardProducts(values, 'buyerDash')
        },
    })

    useEffect(() => {
        if (action !== '') {
            console.log(action, 'acttt')
            formik.values.limit = 12
            getAllDashboardProducts(
                {
                    limit: 12,
                    page: 1,
                    orderby: 'p.date_closed, asc',
                    order: '',
                    user_id: props.userId,
                    action: action,
                },
                'buyerDash'
            )
            setIsLoading(true)
        }
    }, [action])

    const tableActions = []

    useEffect(() => {
        setInitialUpdate(true)
        console.log(action, 'outside action')
        let arrayVal = []
        arrayVal.push({
            field: 'title',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Auction',
            active: 1,
            view_page: 1,
        })
        if (action === 'winning') {
            arrayVal.push(
                {
                    field: 'wprice',
                    type: 'price',
                    firstChild: false,
                    sort: true,
                    sortField: 'p.wprice',
                    disablePadding: false,
                    label: 'Bid',
                    active: 1,
                },
                {
                    field: 'date_closed',
                    type: 'datetime',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Date',
                    active: 1,
                }
            )
        } else if (action === 'outbid') {
            arrayVal.push(
                {
                    field: 'wprice',
                    type: 'price',
                    firstChild: false,
                    sort: true,
                    sortField: 'p.wprice',
                    disablePadding: false,
                    label: 'Bid',
                    active: 1,
                },
                {
                    field: 'date_closed',
                    type: 'datetime',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Date',
                    active: 1,
                }
            )
        } else if (action === 'won') {
            arrayVal.push(
                {
                    field: 'buynow_common_invoice',
                    type: '',
                    firstChild: false,
                    sort: true,
                    disablePadding: false,
                    label: 'Invoice#',
                    active: 1,
                    view_page: 1,
                },
                {
                    field: 'wprice',
                    type: 'price',
                    firstChild: false,
                    sort: true,
                    sortField: 'p.wprice',
                    disablePadding: false,
                    label: 'Amount',
                    active: 1,
                },
                {
                    field: 'date_closed',
                    type: 'datetime',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Date',
                    active: 1,
                }
            )
        } else {
            arrayVal.push(
                {
                    field: 'wprice',
                    type: 'price',
                    firstChild: false,
                    sort: true,
                    sortField: 'p.wprice',
                    disablePadding: false,
                    label: 'Amount',
                    active: 1,
                },
                {
                    field: 'bids_created_at',
                    type: 'datetime',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Bid Date',
                    active: 1,
                },
                {
                    field: 'date_closed',
                    type: 'datetime',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Auction end Date',
                    active: 1,
                }
            )
        }
        setArrayValue(arrayVal)
        setInitialUpdate(false)
    }, [action])

    useEffect(() => {
        if (
            search_alldashboardproducts.from === 'buyerDash' &&
            search_alldashboardproducts.records.length
        ) {
            console.log('hell', search_alldashboardproducts)
            setTableBody(search_alldashboardproducts.records)
            setIsLoading(false)
        } else {
            setTableBody([])
            setIsLoading(false)
        }
    }, [search_alldashboardproducts])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const resetForm = () => {
        console.log(action, 'acttt')
        formik.values.action = action
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        getAllDashboardProducts(formik.values, 'buyerDash')
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const id = open ? 'adv-popover-2' : undefined
    const actionFunction = (data) => {
        setAction(data)
        formik.values.action = data
    }

    return (
        <div className="innerTabs">
            <AppBar position="static">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="buyer dashboard"
                >
                    <Tab
                        label={winningLabel}
                        {...a11yProps(0)}
                        onClick={() => actionFunction('winning')}
                    />
                    <Tab
                        label={outbidLabel}
                        {...a11yProps(1)}
                        onClick={() => actionFunction('outbid')}
                    />
                    <Tab
                        label={wonLabel}
                        {...a11yProps(2)}
                        onClick={() => actionFunction('won')}
                    />
                </Tabs>
            </AppBar>
            {console.log(value, 'seeValue')}
            <TabPanel value={value} index={0}>
                {initialUpdate ? (
                    <Loaders name="table" isLoading={isLoading} />
                ) : (
                    <BaseTablePage
                        arrayValue={arrayValue}
                        isLoading={isLoading}
                        tableBody={tableBody}
                        tableActions={tableActions}
                        allData={search_alldashboardproducts}
                        changeTableFunction={getAllDashboardProducts}
                        propertyColumnReOrder={false}
                        reorder={false}
                        resetForm={resetForm}
                        show_dashboard={true}
                        formik={formik}
                        fromVariable={'buyerDash'}
                    />
                )}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {initialUpdate ? (
                    <Loaders name="table" isLoading={isLoading} />
                ) : (
                    <BaseTablePage
                        arrayValue={arrayValue}
                        isLoading={isLoading}
                        tableBody={tableBody}
                        tableActions={tableActions}
                        allData={search_alldashboardproducts}
                        changeTableFunction={getAllDashboardProducts}
                        propertyColumnReOrder={false}
                        reorder={false}
                        resetForm={resetForm}
                        show_dashboard={true}
                        formik={formik}
                        fromVariable={'buyerDash'}
                    />
                )}
            </TabPanel>
            <TabPanel value={value} index={2}>
                {initialUpdate ? (
                    <Loaders name="table" isLoading={isLoading} />
                ) : (
                    <BaseTablePage
                        arrayValue={arrayValue}
                        isLoading={isLoading}
                        tableBody={tableBody}
                        tableActions={tableActions}
                        allData={search_alldashboardproducts}
                        changeTableFunction={getAllDashboardProducts}
                        propertyColumnReOrder={false}
                        reorder={false}
                        resetForm={resetForm}
                        show_dashboard={true}
                        formik={formik}
                        fromVariable={'buyerDash'}
                    />
                )}
            </TabPanel>
        </div>
    )
}

export default BuyerBids
